export default "__VITE_ASSET__BK1pehhl__"